/**
 * This module defines the sub-routing for FAQ components.
 * This module will be included and used inside the Router object.
 */

export default [
  {
    path: '/faq/licensing',
    component: () => import('@/components/FrequentlyAskedQuestion/pages/Licensing.vue'),
    meta: {
      guest: true,
      fullscreen: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/faq.js